import { Component, OnInit } from '@angular/core';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from 'src/environments/environment';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GasTravel } from 'src/app/models/gas-travel';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-gas-unity-emmit',
  templateUrl: './gas-unity-emmit.component.html',
  styleUrls: ['./gas-unity-emmit.component.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }],
})
export class GasUnityEmmitComponent implements OnInit {
  unities:Unity[] = [];
  unity:Unity = null;
  loading:boolean = false;
  url:string = environment.baseUrl + '/unities/';
  gas_metric_final:number = 0;
  gas_metric_initial:number = 0;
  gasType:string = 'proeco';
  description:string = null;
  unity_ticket:string = '';

  date1:Date = new Date();
  date2:Date = new Date();

  gases:GasTravel[] = [];

  totalReal:number = 0;

  isAdminOrRoot:boolean = false;
  canUnlimitedLoad:boolean = false;

  constructor(private authServ:AuthService, private unitServ:UnityService, private utl:UtilitiesService, private toastr:ToastrManager, private modal:NgbModal) {
    this.date1.setDate(this.date1.getDate() - 7);
  }

  ngOnInit() {
    this.isAdminOrRoot = this.authServ.is('root') || this.authServ.is('admin');
    this.canUnlimitedLoad = this.authServ.has('unlimited-load');
    console.log('isAdminOrRoot: ',this.isAdminOrRoot);
    this.loading = true;
    this.unitServ.getUnities()
      .then(unities => {
        this.unities = unities.filter(x => x.active && ((x.id >= 1000 && x.id < 1250) || (x.id >= 2000 && x.id < 2100)));
        this.unity = this.unities[0];
        this.loading = false;
      })
      .catch(e => {
        this.utl.formatMessages(e);
        this.loading = false;
      });
  }

  save(event) {
    event.preventDefault();

    if (this.gas_metric_initial && this.gas_metric_final && this.unity_ticket) {
      let custom = {
        gas_metric_initial: this.gas_metric_initial, 
        gas_metric_final: this.gas_metric_final, 
        gas_description_proeco: this.description,
        unity_id: this.unity.id,
        gas_date_proeco: new Date(),
        type: 0, 
        unity_ticket: this.unity_ticket,
        gas_type: this.gasType
      };

      this.loading = true;
      this.unitServ.postGas(custom, this.unity)
        .then(resp => {
          this.toastr.successToastr('Creado correctamente');
          this.loading = false;
        }).catch(e => {
          this.toastr.errorToastr(this.utl.formatMessages(e));
          this.loading = false;
        });
    } else {
      this.toastr.infoToastr("Todos los datos son obligatorios!");
    }
  }

  getGasUnity(modal) {
    this.modal.open(modal, {size: 'lg'});
    this.search();
  }

  search () {
    this.loading = true;
    this.unitServ.getGasTravel(this.unity, this.date1, this.date2)
    .then(x => {
        this.gases = x;
        this.totalReal = this.gases.map(x => x.metric_real).reduce((ant, act) => Number(ant) + Number(act), 0);
        this.loading = false;
      });
  }
}
